import { render, staticRenderFns } from "./NicknameSearcher.vue?vue&type=template&id=07ba9470&"
import script from "./NicknameSearcher.vue?vue&type=script&lang=js&"
export * from "./NicknameSearcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports